<template>
  <div class="home-honor">
    <div class="container">
      <div>
        <div class="home-honor-title">{{ $t("home.honor") }}</div>
      </div>
      <div class="home-honor-line"></div>

      <div class="home-honor-list">
        <a
          v-for="(item, index) in honorList"
          :key="index"
          class="home-honor-item"
          :href="item.url || undefined"
          :target="item.url ? '_blank' : undefined"
          :rel="item.url ? 'noopener noreferrer' : undefined"
          @click="onHonorClick($event, item)"
        >
          <img class="home-honor-img" :src="item.img" :alt="item.alt">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import honor1 from '../../assets/home/honor-1.png'
import honor2 from '../../assets/home/honor-2.png'
import honor3 from '../../assets/home/honor-3.png'
import honor4 from '../../assets/home/honor-4.png'
import honor5 from '../../assets/home/honor-5.png'

export default {
  name: 'HomeHonor',
  data() {
    return {
      honorList: [
        {
          img: honor1,
          alt: '全球前2%顶尖科学家',
          url: 'https://mp.weixin.qq.com/s/4JRG0wD6TuzUe-Rzb21G2A',
        },
        {
          img: honor2,
          alt: '2025年中国新经济未来独角兽企业',
          url: 'https://mp.weixin.qq.com/s/uuxqbazal7fcCv66Vq8p4A',
        },
        {
          img: honor3,
          alt: '央视访谈',
          url: 'https://mp.weixin.qq.com/s/nJr4sZPP9p4s4j0gBJTgtA',
        },
        {
          img: honor4,
          alt: '央视纪录片',
          url: 'https://mp.weixin.qq.com/s/fIieyVLCKBzantHdBO6rKQ',
        },
        {
          img: honor5,
          alt: '昇腾AI创新大赛',
          url: '',
        },
      ],
    }
  },
  methods: {
    onHonorClick(event, item) {
      if (!item.url) {
        event.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
.home-honor {
  margin-top: 60px;
  margin-bottom: 60px;
}
.home-honor-title {
  display: inline-block;
  font-size: 32px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(73, 145, 201, 1);
  line-height: 45px;
}
.home-honor-line {
  margin-top: 8px;
  height: 1px;
  background: rgba(240, 240, 240, 1);
}
.home-honor-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
  margin-top: 40px;
}
.home-honor-item {
  flex: 1 1 0;
  min-width: 0;
  display: block;
  cursor: pointer;
  text-decoration: none;
}
.home-honor-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
@media (max-width: 768px) {
  .home-honor-list {
    flex-wrap: wrap;
    gap: 12px;
  }
  .home-honor-item {
    flex: 1 1 calc(50% - 12px);
  }
}
</style>
